import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { Feature, Map } from "ol";
import { ControlPoint } from "src/app/bo/controlPoint";
import MapConstants from '../constants';
import { transform } from 'ol/proj';
import { Point } from "ol/geom";
import { Fill, RegularShape, Stroke, Style, Text } from "ol/style";
import { FeatureLike } from "ol/Feature";
import CircleStyle from "ol/style/Circle";

export class ControlPointsLayer{
    private readonly source :VectorSource;
    private readonly vectorLayer : VectorLayer<VectorSource>;
    private readonly map: Map;
        
    public constructor(map: Map,  zIndex:number){
        this.map = map;
        this.source = new VectorSource();
       
        this.vectorLayer = new VectorLayer({
            source: this.source,
            // style:(feature) => {
            //     this.styleFunction(feature);
            // }
            style:(feature)=> this.staticStyleFunction(feature)
        });
        
       
        this.map.addLayer(this.vectorLayer);
        this.vectorLayer.setZIndex(zIndex);
    }



    public setControlPoints(ctrlPoints: ControlPoint[] ){
        this.source.clear();
        for (var controlPoint of ctrlPoints) {
            var coord = transform([controlPoint.x, controlPoint.y], MapConstants.EPSG_WGS84, MapConstants.EPSG_REFERENCE_OL);
            if (Number.isNaN(coord[0]) == false && Number.isNaN(coord[1]) == false) {
                var point = new Point(coord);
                // var circle = new Circle(
                //     coord,
                //     30
                // );
                //var circleFeature = new Feature(circle);
                var pointFeature = new Feature(point);
                pointFeature.set(MapConstants.FEATURE_NAME, MapConstants.FEATURE_TYPE.controlPoint);
                pointFeature.set(MapConstants.POINT_NAME, controlPoint.name);
                this.source.addFeature(pointFeature);
            }
        }
    }

    public setVisible(visible: boolean): void {
        this.vectorLayer.setVisible(visible);
    }

    private styleFunction(feature: FeatureLike){
        const geometry = feature.getGeometry();
        const type = geometry.getType();
        console.log("geometry:", geometry);
        console.log("type:", type);

        let pointName=  "";
        if(type === "Circle"){
            pointName = feature.get(MapConstants.POINT_NAME);
            console.log("pointName:", pointName);
            
        }
        let styles =[];
       
        labelStyle.getText().setText(pointName);
        //labelStyle.setGeometry(new Point(geometry.getLastCoordinate()));

        styles.push(labelStyle);
        return styles;
    }

    

    private staticStyleFunction(feature: FeatureLike){
        return new Style({
            fill: new Fill({
                color: 'orange'
              }),
            stroke: new Stroke({
                color: '#7E003F',
                width: 2
            }),
            image: new CircleStyle({
                radius: 7,
                fill: new Fill({color: 'orange'}),
                stroke: new Stroke({
                  color: "#7E003F",
                  width: 1
                })
              }),
            text: new Text({
                text: feature.get(MapConstants.POINT_NAME),
                font: '12px Calibri,sans-serif',
                fill: new Fill({
                color: 'rgba(255, 255, 255, 1)',
                }),
                backgroundFill: new Fill({
                color: 'rgba(0, 0, 0, 0.4)',
                }),
                padding: [2, 2, 2, 2],
                textBaseline: 'bottom',
                offsetY: -12,
            })
        });
    }
}

const labelStyle = new Style({
    text: new Text({
        font: '14px Calibri,sans-serif',
        fill: new Fill({
            color: 'rgba(255, 255, 255, 1)',
        }),
        backgroundFill: new Fill({
            color: 'rgba(0, 0, 0, 0.7)',
        }),
        padding: [3, 3, 3, 3],
        textBaseline: 'bottom',
        offsetY: -15,
    }),
    image: new RegularShape({
        radius: 8,
        points: 3,
        angle: Math.PI,
        displacement: [0, 10],
        fill: new Fill({
            color: 'rgba(0, 0, 0, 0.7)',
        }),
    }),
  });